package koala.dom

import kampfire.model.GeoPoint
import koala.modifier.*
import koala.html.configureGeoMapMount
import koala.model.GeoCameraController
import kotlinx.html.DIV

/** A map centered on [initialPoint], returning the controller that moves its camera. */
fun ViewScope.geoMapMount(
    initialPoint: GeoPoint? = null,
    mod: Modifier? = null,
    block: DIV.() -> Unit = {}
): GeoCameraController {
    val element = box {
        configureGeoMapMount(initialPoint, mod, block)
    }

    return wireGeoMap(element)
}